<header class="flex justify-between bg-white border-b shadow">
    <div class="flex items-center">
        @if (isMobile) {
        <button
            (click)="sidebarToggle.emit()"
            aria-label="Toggle sidebar"
            class="px-2 py-1 mr-3 text-xl border rounded focus:outline-none focus:ring focus:ring-blue-200"
        >
            <lucide-icon class="w-6 h-6 text-primary" [img]="Menu"></lucide-icon>
        </button>
        }
    </div>
    <div class="relative flex space-x-2">
        <button
            type="button"
            #notifBtn
            class="relative flex items-center justify-center m-0 transition-all duration-200 rounded-full nav-icon w-9 h-9"
            aria-label="Notifications"
            (click)="toggleNotifPopover()"
        >
            <lucide-icon class="w-5 h-5 transition-colors duration-200 text-primary" [img]="Bell"></lucide-icon>
            @if (unreadCount() > 0) {
            <span
                class="absolute top-0 right-0 flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-tertiary rounded-full"
            >
                {{ unreadCount() > 9 ? "9+" : unreadCount() }}
            </span>
            }
        </button>
        <button
            type="button"
            #profileBtn
            class="flex items-center justify-center m-0 ml-4 transition-all duration-200 rounded-full nav-icon w-9 h-9"
            (click)="toggleProfilePopover()"
            aria-label="Profile"
        >
            <lucide-icon class="w-5 h-5 transition-colors duration-200 text-primary" [img]="User"></lucide-icon>
        </button>
        @if (profilePopoverOpen()) {
        <div
            #profilePopover
            class="absolute right-0 mt-3 min-w-[12rem] rounded-xl border border-gray-200 bg-white shadow-xl z-50 transition-all duration-150"
            style="top: 100%"
        >
            <ul class="py-1">
                <li
                    (click)="changePassword()"
                    class="flex items-center justify-start w-full px-4 py-2 space-x-2 cursor-pointer hover:bg-slate-100"
                >
                    <lucide-icon class="w-5 h-5 text-secondary" [img]="KeyRound"></lucide-icon>
                    <p class="text-sm font-medium text-left text-primary">Change Password</p>
                </li>

                @if (isExternalUser()) {
                <li
                    (click)="voluntaryDelist()"
                    class="flex items-center justify-start w-full px-4 py-2 space-x-2 cursor-pointer hover:bg-slate-100"
                >
                    <lucide-icon class="w-5 h-5 text-secondary" [img]="EyeOff"></lucide-icon>
                    <p class="text-sm font-medium text-left text-primary">Voluntary Delist Profile</p>
                </li>
                }

                <li
                    (click)="logout()"
                    class="flex items-center justify-start w-full px-4 py-2 space-x-2 text-tertiary transition-all duration-150 cursor-pointer rounded-b-xl hover:bg-red-50"
                >
                    <lucide-icon class="w-5 h-5" [img]="LogOut"></lucide-icon>
                    <p class="text-sm font-medium text-left">Logout</p>
                </li>
            </ul>
        </div>
        } @if (notifPopoverOpen()) {
        <div
            #notifPopover
            class="absolute right-0 mt-3 min-w-[20rem] max-w-[24rem] max-h-[28rem] overflow-y-auto rounded-xl border border-gray-200 bg-white shadow-xl z-50 transition-all duration-150"
            style="top: 100%"
        >
            <!-- Header -->
            <div
                class="sticky top-0 z-10 flex items-center justify-between px-4 py-3 bg-white border-b border-gray-200"
            >
                <h3 class="text-sm font-semibold text-gray-800">Notifications</h3>
                @if (unreadCount() > 0) {
                <p
                    (click)="markAllNotificationsAsRead()"
                    class="text-sm font-medium text-blue-600 transition-colors hover:text-blue-800 hover:underline hover:cursor-pointer"
                >
                    Mark all as read
                </p>
                }
            </div>

            <!-- Notification List -->
            @if (notifications().length === 0) {
            <div class="px-4 py-6 text-center">
                <lucide-icon class="w-12 h-12 mx-auto mb-2 text-gray-300" [img]="Bell"></lucide-icon>
                <p class="text-sm text-gray-500">No notifications yet</p>
            </div>
            } @else {
            <ul class="divide-y divide-gray-100">
                @for (notification of notifications(); track notification.id) {
                <li
                    (click)="onNotificationClick(notification)"
                    class="relative px-4 py-3 transition-colors cursor-pointer hover:bg-gray-50"
                    [class.bg-blue-50]="!notification.read_at"
                >
                    <div class="flex items-start space-x-3">
                        <div class="flex-shrink-0">
                            <div class="flex items-center justify-center w-10 h-10 bg-blue-100 rounded-full">
                                <lucide-icon class="w-5 h-5 text-blue-600" [img]="Bell"></lucide-icon>
                            </div>
                        </div>
                        <div class="flex-1 min-w-0 pr-2">
                            <p
                                class="text-sm font-medium text-gray-900"
                                [innerHTML]="notification?.data?.message || notification?.message || 'New notification'"
                            ></p>
                            <p class="mt-1 text-xs text-gray-500">
                                {{ notification.created_at | date : "MMM d, h:mm a" }}
                            </p>
                        </div>
                        @if (!notification.read_at) {
                        <div class="absolute top-3 right-3">
                            <div class="w-2.5 h-2.5 bg-blue-500 rounded-full"></div>
                        </div>
                        }
                    </div>
                </li>
                }
            </ul>
            }
        </div>
        }
    </div>
</header>

<ng-template #voluntaryDelistModal>
    <div class="p-4">
        <p class="mb-4 text-sm text-gray-600">
            Are you sure you want to delist your profile? Please input reason for delisting and supporting docs to
            continue.
        </p>

        <form [formGroup]="delistForm" class="space-y-4">
            <!-- Reason Textarea -->
            <div>
                <label class="block mb-2 text-sm font-medium text-primary">
                    Reason for Delisting <span class="text-red-500">*</span>
                </label>
                <textarea
                    formControlName="reason"
                    rows="4"
                    class="w-full px-3 py-2 input input--primary"
                    [class.input--error]="isFieldInvalid('reason')"
                    placeholder="Please provide your reason"
                ></textarea>
                @if (isFieldInvalid('reason')) {
                <div class="flex items-center mt-1 text-xs text-red-600">
                    <lucide-icon class="w-4 h-4 mr-2" [img]="CircleAlert"></lucide-icon>
                    {{ getFieldError("reason") }}
                </div>
                }
            </div>

            <!-- File Upload -->
            <div>
                <label class="block mb-2 text-sm font-medium text-primary">
                    Upload Supporting Docs <span class="text-red-500">*</span>
                </label>
                <app-file-upload
                    [acceptedTypes]="'.pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx'"
                    [maxFileSize]="5242880"
                    [maxFiles]="1"
                    [multiple]="false"
                    [showImageThumbnails]="true"
                    placeholder="Attach supporting document (PDF, DOC, DOCX, XLS, XLSX, JPG, PNG) - Required"
                    subText="Max file size: 5MB. Only 1 file required."
                    (filesSelected)="onFileSelected($event)"
                    (fileRemoved)="onFileRemoved($event)"
                    (validationError)="onFileValidationError($event)"
                ></app-file-upload>
            </div>

            <!-- Action Buttons -->
            <div class="flex flex-col gap-3 pt-6 border-t border-gray-200 sm:flex-row sm:justify-end sm:gap-4">
                <button
                    type="button"
                    class="w-full px-5 py-2.5 text-sm font-semibold border border-primary rounded-lg text-primary sm:w-auto hover:bg-gray-100"
                    (click)="confirmCancelVoluntaryDelist()"
                    [disabled]="isSubmitting"
                >
                    Cancel
                </button>
                <app-button
                    type="button"
                    class="w-md sm:w-auto"
                    label="Submit"
                    loadingText="Submitting..."
                    [isLoading]="isSubmitting"
                    (click)="confirmSubmitVoluntaryDelist()" 
                    btnClass="button button--primary transition font-semibold rounded-lg text-sm w-full px-5 py-2.5 text-center flex items-center justify-center"
                ></app-button>
            </div>
        </form>
    </div>
</ng-template>

<!-- active Request Warning Modal -->
<ng-template #activeRequestWarningModal let-status="status">
    <div class="p-6">
        <div class="flex flex-col items-center mb-4 text-center">
            <div class="flex items-center justify-center w-20 h-20 mb-4 rounded-full bg-secondary-20">
                <lucide-icon class="w-10 h-10 text-secondary" [img]="TriangleAlert"></lucide-icon>
            </div>
            <div>
                <h3 class="text-lg font-medium text-gray-900">You still have an existing delisting request</h3>
                <div class="mt-2 text-sm text-gray-600">
                    <p><strong class="text-primary">Current Status:</strong> {{ status }}</p>
                    <p class="mt-2">
                        Please wait for your current request to be processed before submitting a new one.
                    </p>
                </div>
            </div>
        </div>

        <div class="flex justify-center mt-6">
            <button
                type="button"
                class="px-5 py-2.5 text-white text-sm font-medium rounded bg-primary hover:bg-primary-80"
                (click)="closeModal()"
            >
                OK, I understand
            </button>
        </div>
    </div>
</ng-template>

<ng-template #notEligibleWarningModal>
    <div class="flex flex-col items-center justify-center p-6 space-y-4">
        <div class="flex items-center justify-center w-16 h-16 bg-yellow-100 rounded-full">
            <lucide-icon class="w-8 h-8 text-yellow-600" [img]="TriangleAlert"></lucide-icon>
        </div>
        
        <p class="text-center text-gray-700">
            Only registrants with finally approved applications can submit voluntary delisting requests.
        </p>
        
        <button
            (click)="currentModalId !== null && modalService.close(currentModalId)"
            class="px-6 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700"
        >
            OK, I understand
        </button>
    </div>
</ng-template>


<!-- Cancel Voluntary Delist Confirmation -->
<ng-template #cancelVoluntaryDelistConfirmModal let-onConfirm="onConfirm">
    <div class="w-full max-w-md">
        <p class="mb-6 text-gray-700">
            Are you sure you want to cancel? All unsaved changes will be lost.
        </p>
        <div class="flex justify-end space-x-4">
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold border border-primary text-primary rounded hover:bg-gray-100 transition"
                data-cancel
            >
                No, Go Back
            </button>
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-white bg-tertiary rounded hover:bg-red-700 transition"
                (click)="onConfirm()"
            >
                Yes, Cancel
            </button>
        </div>
    </div>
</ng-template>

<!-- Submit Voluntary Delist Confirmation -->
<ng-template #submitVoluntaryDelistConfirmModal let-onConfirm="onConfirm">
    <div class="w-full max-w-md">
        <p class="mb-6 text-gray-700">
            Are you sure you want to submit this delisting request? This action cannot be undone.
        </p>
        <div class="flex justify-end space-x-4">
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold border border-primary text-primary rounded hover:bg-gray-100 transition"
                data-cancel
            >
                No, Go Back
            </button>
            <app-button
                type="button"
                class="w-md sm:w-auto"
                label="Yes, Submit"
                loadingText="Submitting..."
                [isLoading]="isSubmitting"
                btnClass="button button--primary transition font-semibold rounded-lg text-sm w-full px-5 py-2.5 text-center flex items-center justify-center"
                (click)="onConfirm()"
            ></app-button>
        </div>
    </div>
</ng-template>